import listaQuestionarios from "./questionarios";
import listaPerguntasQuestionarios from "./questionariosPerguntas";

async function questionariosComPerguntas(token) {
    let todasAsPerguntas = await listaPerguntasQuestionarios(token);
    let questionarios = await listaQuestionarios(token);

    questionarios.forEach((questionario) => {
        let perguntasDoQuestionario = todasAsPerguntas.filter(
            (pergunta) => pergunta.idQuestionario == questionario.id
        );

        questionario.fields = perguntasDoQuestionario;
    });

    return questionarios;
}

export default questionariosComPerguntas;

/*
24/02/2021 - Estevam e Robson

Atualmente, temos 2 endpoints que retornam as inforamções de questionários e perguntas relacionadas a todos os questionários

let questionarios[] = api.getQuestionarios
let perguntas[] = api.getPerguntas

No array de perguntas, temos todas as perguntas, de todos os questionários, o que ajuda na performance, mas complica para selecionar
as perguntas de um determinado questionário.
A ideia aqui é fazer um "merge", unificando as perguntas ao respectivo questionário de forma a ter um array de perguntas dentro do objeto questionário.

Objetivo: Mesclar o array de questionários com o array de perguntas, 
para facilitar a manipulação do objeto "questionários" na aplicação


Ficando assim:

[
  {
    id: 1
    questionario: "Automóvel"
    perguntas: [
      {
        id: 100,
        descricao: "Possui rádio?"
      },
      {
        id: 101,
        descricao: "Possui Toca Cd"
      }
    ]
  }
  ,
  {
    id: 2
    questionario: "Caminhôes"
    perguntas: [
      {
        id: 100,
        descricao: "Possui filtro de ar"
      },
      {
        id: 101,
        descricao: "CLRV"
      }
    ]
  }
]
*/
